import * as Util from "../common/util";
import * as Data from "../interfaces/data";

export interface IChangePasswordRequest {
        CurrentPassword: string;
        NewPassword: string;
        NewPasswordConfirm: string;
}

export interface IChangePasswordResponse {
       CurrentPasswordMatches: boolean;
       ShouldReauthenticate: boolean;
}

export interface IPasswordRequirementsResponse {
    MinimumPasswordLength: number;
    PasswordComplexityRequirements: string;
}

export interface IUserEditMaster {
    ID: number;
    CustomerID: number;
    FirstName: string;
    LastName: string;
    UserName: string;
    Email: string;
    Password: string;
    ConfirmPassword: string;
    ResetPasswordOnNextLogin: boolean;
    IsActive: boolean;
    UserCustomerIsActive: boolean;
    Roles: string[];
    TimeZoneID?: number;
    TimeZones?: Array<Data.ICodeModel<number>>;
}

export interface IUserRequest {
    UserID: number;
}
export function GetPasswordRequirements(): JQueryDeferred<Data.IResponse<IPasswordRequirementsResponse>> {
    return Util.callWebService(
        "/api/User/PasswordRequirements",
        "GET");
}

export function GetUser(request: IUserRequest): JQueryDeferred<Data.IResponse<IUserEditMaster>> {
    return Util.callWebService(
        "/api/User/GetUser", "POST", request);
}

export interface IUserResponse {
    ID: number;
}

export function SaveUser(user: any): JQueryDeferred<Data.IResponse<IUserResponse>> {
    return Util.callWebService(
        "/api/User/SaveUser", "POST", user);
}

export function ChangeUserStatus(userID: number, isActive: boolean): JQueryDeferred<Data.IResponse<any>> {
    return Util.callWebService(
        "/api/User/ChangeUserStatus",
        "POST",
        {
            ID: userID,
            UserCustomerIsActive: isActive,
        });
}

export function ChangePassword(request: IChangePasswordRequest): JQueryDeferred<Data.IResponse<IChangePasswordResponse>> {
    return Util.callWebService(
        "/api/User/ChangePassword",
        "POST",
        request);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/data/userData.ts